import AutoPlace from './AutoPlace';
import AutoPlaceSelectionBehavior from './AutoPlaceSelectionBehavior';

export default {
  __init__: [ 'autoPlaceSelectionBehavior' ],
  autoPlace: [ 'type', AutoPlace ],
  autoPlaceSelectionBehavior: [ 'type', AutoPlaceSelectionBehavior ]
};